import { get } from "ol/proj";
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { ProjectionModel } from '../model/map.model';
import { SpanMapModel, TowerMapModel } from '../../../model/map.model';
import { PALETTE } from '../../../config/general.config';
import { Fill, Text } from 'ol/style';
import { Task, TASK_STATUS_ORDER, TaskStatus } from "../../go/model/task.model";
import { Stroke } from 'ol/style.js';

export const createProjectionName = (projection: ProjectionModel): string => {
  return `${projection.type}:${projection.srid}`;
}

export const registerProjection = (projection: ProjectionModel) => {
  const projectionName = createProjectionName(projection);
  const projExists = get(projectionName);

  // hack copied from Ensys
  // +axis=neu is a hack / fix for polish projections, more info below
  // https://proj.org/usage/projections.html#axis-orientation
  // https://github.com/openlayers/openlayers/issues/5182#issuecomment-206342137

  if (!projExists) {
    proj4.defs(projectionName, projection.proj + "+axis=neu");
    register(proj4);
  }
}

export const getTowerIcon = (tower: TowerMapModel): string => {
  const statusToColorMap: Record<string, string> = {
    "CLOSED": "green",
    "DRAFT": "white",
    "IN_PROGRESS": "blue",
    "TO_ACCEPT": "yellow",
    "CANCELLED": "gray"
  };

  let icon = 'tower';

  if (tower.tasks && tower.tasks.length > 0) {
    icon = tower.tasks.length === 1 ? statusToColorMap[tower.tasks[0].status] || 'tower' : 'red';
  } else if (tower.externalId.startsWith('SE')) {
    icon = 'station';
  }

  return `assets/icons/${icon}-pin.svg`;
}

export const getSpanColor = (span: SpanMapModel): string => {

  if (!span.tasks || !span.tasks.length) {
    return PALETTE.BLACK;
  }

  if (span.tasks && span.tasks.length > 1) {
    return PALETTE.RED;
  }

  const status = span.tasks[0].status;

  let color;

  switch (status) {
    case 'TO_ACCEPT':
      color = PALETTE.YELLOW;
      break;
    case 'IN_PROGRESS':
      color = PALETTE.BLUE;
      break;
    case 'DRAFT' :
      color = PALETTE.WHITE;
      break;
    case "CLOSED":
      color = PALETTE.GREEN;
      break;
    case "CANCELLED":
      color = PALETTE.GREY;
      break;
  }

  return color;
}

export const setDefectsNoSpanText = (tasks: Task[]) => {
  const defectsNo = tasks.reduce((acc, item) => acc + (item.failureCount || 0), 0);

  return new Text({
    text: defectsNo ? defectsNo.toString() : '',
    font: '13px Roboto,sans-serif',
    fill: new Fill({ color: '#000' }),
    stroke: new Stroke({
      color: '#fff', width: 2
    }),
    placement: 'point',
  })
}

export const setDefectsNoTowerText = (tasks: Task[]) => {
  const defectsNo = tasks.reduce((acc, item) => acc + (item.failureCount || 0), 0);

  return new Text({
    text: defectsNo ? defectsNo.toString() : '',
    font: '11px Roboto,sans-serif',
    fill: new Fill({ color: '#000' }),
    placement: 'point',
  })
}

export const setTasksOrder = (tasks: Task[]): Task[] => {
  return tasks.sort((a, b) => {
    return TASK_STATUS_ORDER[a.status as TaskStatus] - TASK_STATUS_ORDER[b.status as TaskStatus];
  });
}
